module.exports = __webpack_public_path__ + "static/media/netherlands.123024f1.svg";